export default __webpack_public_path__ + "static/media/desktop.a2fd6765.jpg";